import * as actionTypes from "./KitTypes";

const INITIAL_STATE = {
    kitList: [],
    itemsList: [],
    itemsInKit: [],
    usersInKit: [],
    kitItem: null,
    kitSettings: null,
    basicFilterData: []
};

const KitReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETKITLIST:
            return {
                ...state,
                kitList: action.payload.list,
            };
        case actionTypes.SETITEMSLIST:
            return {
                ...state,
                itemsList: action.payload.list,
            };
        case actionTypes.SETITEMSINKIT:
            return {
                ...state,
                itemsInKit: action.payload.list,
            };
        case actionTypes.SETUSERSINKIT:
            return {
                ...state,
                usersInKit: action.payload.list,
            };
        case actionTypes.SETKITITEM:
            return {
                ...state,
                kitItem: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                kitItem: null
            };
        case actionTypes.SETKITSETTINGS:
            return {
                ...state,
                kitSettings: action.payload.list
            };
        case actionTypes.SETKITBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default KitReducer;